export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      FunctionInfo: {
        FunctionId: 4,
        FunctionName: '警戒レベル告知機能',
        DeliveryType: 'keikai'
      }
    }
  }
}